export default "__VITE_ASSET__93b4897a__"